import React, { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@hooks/index';
import ConditionalRendering from '@components/common/conditional-rendering/ConditionalRendering';
import HistoricalDocumentsView from '../components/HistoricalDocumentsView';
import { type IHistoricalDocumentsFetchRequest } from '../constants';
import { fetchMemberHistoricalDocuments, resetMemberHistoricalDocuments } from '@actions/individualPortal/historicalDocuments/memberHistoricalDocumentsActionCreators';

const HistoricalDocumentsContainer: React.FC = () => {
    const dispatch = useAppDispatch();
    const { hasLoaded, documents, totalCount, pageNumber, pageSize, sortColumn, sortOrder, hasLoadError } =
        useAppSelector(state => state.individualPortal.memberHistoricalDocuments);

    const handleFetch = useCallback(
        (options: Partial<IHistoricalDocumentsFetchRequest>) => {
            dispatch(fetchMemberHistoricalDocuments(options));
        },
        [dispatch],
    );

    useEffect(() => {
        handleFetch({});
    }, [handleFetch]);

    useEffect(() => {
        return () => {
            dispatch(resetMemberHistoricalDocuments());
        };
    }, [dispatch]);

    return (
        <ConditionalRendering isTrue={hasLoaded}>
            <HistoricalDocumentsView
                documents={documents}
                totalCount={totalCount}
                pageNumber={pageNumber}
                pageSize={pageSize}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                hasLoadError={hasLoadError}
                onFetch={handleFetch}
            />
        </ConditionalRendering>
    );
};

export default HistoricalDocumentsContainer;
